export default "__VITE_ASSET__fc6d1e37__"